import { useEffect, useId } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/paraplanningDashboard/Cross.svg";
import PrimaryButton from "../Buttons/PrimaryButton";
import SecondaryButton from "../Buttons/SecondaryButton";
import "../../../css/DesignSystem/Popups/Popup.css";

const Popup = ({
  open,
  title,
  description,
  icon = null,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  showCancel = true,
  titleAlign = "center",
  busy = false,
  onConfirm,
  onCancel,
  children,
  className = "",
  titleClassName = "FP_H4",
}) => {
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !busy) onCancel?.();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [busy, onCancel, open]);

  if (!open) return null;

  return (
    <div
      className="ds-confirmation-popup-overlay"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onCancel?.();
      }}
    >
      <div
        className={`ds-confirmation-popup ${titleAlign === "left" ? "ds-confirmation-popup--title-left" : ""} ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={description ? descriptionId : undefined}
      >
        <div className="ds-confirmation-popup-header">
          {icon ? (
            <span className="ds-confirmation-popup-icon" aria-hidden="true">
              {icon}
            </span>
          ) : null}
          <div className="ds-confirmation-popup-copy">
            <h4 id={titleId} className={titleClassName}>
              {title}
            </h4>
            {description ? (
              <div id={descriptionId} className="FP_Content">
                {description}
              </div>
            ) : null}
          </div>
          <button
            type="button"
            className="ds-confirmation-popup-close"
            onClick={onCancel}
            disabled={busy}
            aria-label="Close confirmation"
          >
            <CloseIcon aria-hidden="true" />
          </button>
        </div>
        {children}
        <div className="ds-confirmation-popup-actions">
          {showCancel && <SecondaryButton
            type="button"
            label={cancelLabel}
            disabled={busy}
            onClick={onCancel}
          />}
          <PrimaryButton
            type="button"
            label={confirmLabel}
            disabled={busy}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default Popup;
